export const SHOW_WARNING_POPUP = "SHOW_WARNING_POPUP"
export const HIDE_WARNING_POPUP = "HIDE_WARNING_POPUP"